import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import Select from "react-select";
import { CustomSelectDropdown } from "./custom.select";
import languages from "../../../shared/fixtures/languages";
import { selectStyle } from "../../../shared/fixtures/select_style";
import { P } from "../Texts";

export const Language = (props) => {
  const formCtx = useFormContext();
  const {
    formState: { errors: formStateErrors },
  } = formCtx;
  return (
    <>
      <label htmlFor={props.name}>
        <P fontSize="14px" fontFamily="semi" color="#47495C" className="mb-2">
          {props.label}
          <span
            className=""
            style={{
              color: "#E62250",
            }}
          >
            *
          </span>
        </P>
      </label>

      <Controller
        control={props.control}
        {...props}
        defaultValue={props.defaultValue || []}
        rules={props.validation}
        render={({ field }) => (
          <CustomSelectDropdown
            styles={selectStyle}
            {...field}
            options={languages}
            isMulti={props.isMulti}
          />
        )}
      />

      {/* <Controller
        defaultValue={props.defaultValue || []}
        control={props.control}
        {...props}
        render={({ onChange, value, ref }) => (
          <Select
            styles={selectStyle}
            inputRef={ref}
            isMulti={props.isMulti}
            value={value}
            options={languages}
            onChange={onChange}
          />
        )}
        rules={props.validation}
      /> */}

      {formStateErrors[props.name] &&
        formStateErrors[props.name].type === "validate" && (
          <P fontSize="12px" className="mt-2 mb-4 text-red-400 text-sm">
            Select at least one language
          </P>
        )}
      {formStateErrors[props.name] &&
        formStateErrors[props.name].type !== "validate" && (
          <P fontSize="12px" className="mt-2 mb-4 text-red-400 text-sm"></P>
        )}
    </>
  );
};
